import styles from './General.module.scss'
import React, { ReactElement, useMemo } from 'react'
import { GuideComponent } from '@/components/static/StudyMaterialsGuidePage/GuideComponents/GuideComponent.types'
import Tooltip from 'antd/lib/tooltip'
import { STUDY_TIPS } from '@/components/static/StudyMaterialsGuidePage/GuideComponents/General/Tips'
import { reusableCssClass } from '@/utils/reusableCssClasses'
import { UiLayoutConstant } from '@/globals/uiLayoutConstant'
import sharedStudyGuideStyles from '../../StudyMaterialsGuidePage.module.scss'
import { BackToTop } from '@/components/static/BackToTop/BackToTop'
import { ClickableArrow } from '@/components/ClickableArrow/ClickableArrow'
import Anchor from 'antd/lib/anchor/Anchor'

export const TipsGuidePage: React.FC<GuideComponent> = (
    props
): ReactElement => {
    const parameters = useMemo((): {
        renderedTips: ReactElement[]
        anchorData: { key: string; href: string; title: string }[]
    } => {
        const renderedTips: ReactElement[] = []
        const anchorData: { key: string; href: string; title: string }[] = []
        Object.entries(STUDY_TIPS).forEach(([indexStr, studyTip]) => {
            renderedTips.push(
                <div id={`tip-${indexStr}`} key={`tip-${indexStr}`}>
                    <div className={styles.subtitle}>{studyTip.title}</div>
                    <div>{studyTip.text}</div>
                    <br />
                </div>
            )

            anchorData.push({
                key: `tip-${indexStr}`,
                href: `#tip-${indexStr}`,
                title: studyTip.title,
            })
        })
        return { renderedTips, anchorData }
    }, [])

    return (
        <div
            className={sharedStudyGuideStyles.studyMaterialsGuidePageBackground}
        >
            <BackToTop isLoggedIn={props.isLoggedIn} />

            <div className={sharedStudyGuideStyles.studyMaterialsGuidePage}>
                <div className={sharedStudyGuideStyles.headerContainer}>
                    <div className={reusableCssClass.centerChildrenVertically}>
                        <Tooltip
                            title={'Return to Overview'}
                            placement={'right'}
                        >
                            <ClickableArrow
                                orientation={'left'}
                                linkDestination={
                                    UiLayoutConstant.STUDY_MATERIALS_GUIDE_PAGE
                                }
                            />
                        </Tooltip>
                    </div>
                </div>
                <div className={sharedStudyGuideStyles.title}>General Tips</div>
                <div className={styles.generalGuideComponentContainer}>
                    <div className={styles.leftColumn}>
                        {...parameters.renderedTips}
                    </div>
                    {!props.shouldStackImagesAndBullets && (
                        <div className={styles.rightColumn}>
                            <div className={styles.anchorContainer}>
                                <Anchor items={parameters.anchorData} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
